export default __webpack_public_path__ + "static/roadmap@2x-a609c787ea69487704b07a9f04f81e7a.png";